// Company Facts: {{fact.key}} placeholders in prompt text are resolved from the
// PromptFacts table by sp_GetSystemPrompt (db/05). These helpers are the admin
// page's view of the same rule.

const TOKEN_RE = /\{\{([^{}\s]{1,100})\}\}/g;

// Every distinct {{token}} used in the given prompt rows -> Map(token -> [promptKey,...]).
export function placeholderUsage(prompts) {
  const usage = new Map();
  for (const p of prompts || []) {
    if (!p?.PromptText) continue;
    for (const m of p.PromptText.matchAll(TOKEN_RE)) {
      const list = usage.get(m[1]) || [];
      if (!list.includes(p.PromptKey)) list.push(p.PromptKey);
      usage.set(m[1], list);
    }
  }
  return usage;
}

// Placeholders that no fact defines. The AI would see the literal {{token}}.
export function unresolvedPlaceholders(prompts, facts) {
  const known = new Set((facts || []).map((f) => f.FactKey));
  const out = [];
  for (const [token, keys] of placeholderUsage(prompts)) {
    if (!known.has(token)) out.push({ token, promptKeys: keys });
  }
  return out;
}

export function factPayload({ key, value, verifiedOn, by }) {
  const payload = { fact_key: key, fact_value: value, updated_by: by || "admin" };
  if (verifiedOn !== undefined) payload.verified_on = verifiedOn; // null clears; omitted preserves
  return payload;
}

export function todayIso(now = new Date()) {
  const p = (n) => String(n).padStart(2, "0");
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}

export function factsByCategory(facts) {
  const groups = {};
  for (const f of facts || []) (groups[f.Category] ||= []).push(f);
  const order = ["company", "insurance"];
  const cats = [...order.filter((c) => groups[c]), ...Object.keys(groups).filter((c) => !order.includes(c)).sort()];
  return cats.map((c) => [c, groups[c].sort((a, b) => (a.SortOrder - b.SortOrder) || a.FactKey.localeCompare(b.FactKey))]);
}
